import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import abilities from "@/composables/abilities";

import store from '@/store/index'

import {UPDATE_APP_LOADING_STATUS, UPDATE_APP_MODULE_LOADING_STATUS} from '@/store/mutation-types'

import LayoutBasicView from '@/views/Layouts/LayoutBasic'

import LayoutLoginView from '@/views/Auth/LayoutLogin.vue'
import ConnexionView from '@/views/Auth/Connexion.vue' 
import ForgotPasswordView from '@/views/Auth/ForgotPassword.vue'
import CreatePasswordView from '@/views/Auth/CreatePassword.vue'
import ResetPasswordView from '@/views/Auth/ResetPassword.vue'
import CreateAccountView from '@/views/Auth/Register/Index.vue'
import AccountDeletionRequestView from '@/views/Auth/AccountDeletionRequest.vue'
import PermissionDeniedView from '@/views/Auth/PermissionDenied.vue'
import NotFoundPageView from '@/views/NotFoundPage.vue'

import ContactListView from '@/views/Contact/Index'
import ContactDetailView from '@/views/Contact/View'
import {isSubDomain} from "@/mixins/Helpers";

import moduleAbilities from "@/composables/moduleAbilities";
import ShopRoutes, {posRoute} from "@/Modules/Shop/router/index"
import {licenseModules, useLicense} from "@/composables/useLicense";

const checkPermission = async (permissions) => {
    let hasAccess = false;
    if(typeof permissions !== 'object')  permissions = [permissions]
    for(let permission of permissions ){
        if (!hasAccess) {
            await axios
                .get(`/permission/${permission}`)
                .then(res => {
                    hasAccess = res.data?.hasPermission
                })
                .catch(() => {
                    hasAccess = false
                })
        }
    }

    return hasAccess
}

const checkModule = async (accessModules) => {
    let hasModuleAccess = false;
    if(typeof accessModules !== 'object')  accessModules = [accessModules]

    for(let accessModule of accessModules ){
        if (!hasModuleAccess) {
            await axios
                .get(`check/module/${accessModule}`)
                .then((response) => {
                    hasModuleAccess = response.data.enabled;
                })
                .catch(() => {
                    hasModuleAccess = false
                })
        }
    }
    return hasModuleAccess
}

const routes = [
    /*
   |--------------------------------------------------------------------------
   | Authentication Routes
   |--------------------------------------------------------------------------|
   */

    {
        path: '/account',
        name: 'create-account',
        meta: { redirectIfAuthenticated: true, redirectIfTenant: true },
    },
    {
        path: '/create_account',
        name: 'create_account',
        component: CreateAccountView,
        meta: { redirectIfAuthenticated: true, redirectIfTenant: true },
    },
    {
        path: '/delete_account',
        name: 'delete-account-request',
        component: AccountDeletionRequestView,
        meta: { redirectIfAuthenticated: true, requiresAuth: false, requiresTenant: false },
    },
    {
        path: '/',
        component: LayoutLoginView,
        meta: { requiresTenant: true },
        children: [
            {
                path: '/',
                component: ConnexionView,
                meta: { redirectIfAuthenticated: true, image: 'kshop_login.png' },
            },
            {
                path: 'login',
                name: 'login',
                component: ConnexionView,
                meta: { redirectIfAuthenticated: true, image: 'kshop_login.png' },
            },
            {
                path: 'confirm/:id/:token/create_password',
                component: CreatePasswordView ,
                name: 'create-password',
                meta: { redirectIfAuthenticated: false, image: 'resetPassword.png' },
            },

            {
                path: 'forgot-password',
                component:  ForgotPasswordView ,
                name: 'forgot-password',
                meta: { redirectIfAuthenticated: true, image: 'kshop_forgot_password.png' },
            },
            {
                path: 'reset/:token/password',
                component: ResetPasswordView ,
                name: 'reset-password',
                meta: { redirectIfAuthenticated: true, image: 'resetPassword.png' },
            },

        ]

    },
    /*
    |--------------------------------------------------------------------------
    | Admin Backend Routes
    |--------------------------------------------------------------------------|
    */
    {
        path: '/admin',
        name: 'admin',
        redirect: { name: 'shop-dashboard' },
        component: LayoutBasicView,
        meta: { requiresAuth: true, requiresTenant: true },
        children: [
            /*
            |--------------------------------------------------------------------------
            | Admin Backend Routes
            |--------------------------------------------------------------------------|
            */
            {
                path: 'dashboard',
                name: 'shop-dashboard',
                component: () => import('@/Modules/Shop/views/Statistics/index.vue'),
                meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.DASHBOARD] }
            },
            {
                path: 'contacts',
                component: ContactListView,
                name: 'contacts-path',
                meta: { requiresPermission: abilities.VIEW_CONTACT , requiresAccess: [moduleAbilities.CONTACT ]  },
            },
            {
                path: 'contact/:id/view',
                component: ContactDetailView,
                name: 'contact-view-path',
                meta: { requiresPermission: abilities.VIEW_CONTACT },
                redirect: { name: 'contact-fiche' },
                children: [
                    {
                        path: '',
                        name: 'contact-fiche',
                        component: () => import('@/views/Contact/components/UpdateContact.vue'),
                        meta: { showLoader: false },
                    },
                    {
                        path: 'addresses',
                        name: 'contact-addresses',
                        component: () => import('@/views/Contact/components/ContactAddress.vue'),
                        meta: { showLoader: false },
                    },
                ]
            },

            /*
             |--------------------------------------------------------------------------
             | Module Routes
             |--------------------------------------------------------------------------|
             */
            {
                path: 'modules',
                children: [
                    {
                        path: '',
                        component:  () => import('@/views/Module/Index.vue'),
                        name: 'modules',
                    }
                ]
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => import('../views/Settings/IndexView.vue'),
                meta: { requiresAuth: true ,requiredPermission : abilities.VIEW_SETTINGS
                },
            },
            {
                name: "settings-system-new",
                path: "settings-society",
                component: () => import('../views/Settings/Layout/BaseSettingSocietyLayout.vue'),
                children: [
                    {
                        name: "settings-company",
                        path: "company",
                        component: () => import('@/views/Settings/Company/Index.vue'),
                        meta: { requiresPermission: abilities.VIEW_COMPANY },
                    },

                    {
                        name: "settings-multiSociety",
                        path: "societies",
                        component: () => import('../views/Settings/Company/Society.vue'),
                        meta: { requiresPermission:  '' }

                    },
                    {
                        name: "settings-multiOffice",
                        path: "offices",
                        component: () => import('../views/Settings/Company/Office.vue'),
                        meta: { requiresPermission:  ''}
                    },
                    {
                        name: "settings-office-users",
                        path: "offices/:id/users",
                        component: () => import('@/views/Settings/Company/Office/UserView'),
                        meta: { requiresPermission: abilities.VIEW_DEPARTMENT },
                    },
                ]
            },
            {
                name: "settings-items",
                path: "settings-items",
                component: () => import('../views/Settings/Layout/BaseSettingProductLayout.vue'),
                children: [
                    {
                        name: "settings-taxes",
                        path: "taxes",
                        component: () => import('@/views/Settings/Tax/IndexView'),
                        meta: { requiresPermission: abilities.VIEW_TAX, requiresLicense: licenseModules.TAX_WEB },
                    },
                    {
                        path: '',
                        component:  () => import('@/views/Settings/Product/Index.vue'),
                        name: 'items',
                        meta: { requiresPermission: abilities.VIEW_PRODUCT, requiresLicense: licenseModules.PRODUCT_WEB }
                    },
                    {
                        path: 'lot',
                        component:  () => import('@/views/Settings/Lot/Index.vue'),
                        name: 'lot',
                        meta: { requiresPermission: abilities.VIEW_LOT, requiresLicense: licenseModules.LOT_WEB }
                    },
                    {
                        path: 'details',
                        component:  () => import('@/views/Settings/Product/details.vue'),
                        name: 'items-details',
                        meta: { requiresPermission: abilities.CREATE_PRODUCT,requiresLicense: licenseModules.PRODUCT_WEB  }
                    },
                    {
                        path: 'attributes',
                        component:  () => import('@/views/Settings/Attribute/Index.vue'),
                        name: 'attributes',
                        meta: { requiresPermission: abilities.VIEW_ATTRIBUT,requiresLicense: licenseModules.ATTRIBUT_WEB },
                    },
                    {
                        path: 'brands',
                        component:  () => import('@/views/Settings/Brand/Index.vue'),
                        name: 'brands',
                        meta: { requiresPermission: abilities.VIEW_BRAND ,requiresLicense: licenseModules.BRAND_WEB },
                    },
                    {
                        path: 'categories',
                        component:  () => import('@/views/Settings/Category/Index.vue'),
                        name: 'categories',
                        meta: { requiresPermission: abilities.VIEW_CATEGORY,requiresLicense: licenseModules.CATEGORY_WEB  },
                    },
                     {
                        path: 'reason',
                        component:  () => import('@/views/Settings/Reason/Index.vue'),
                        name: 'reason',
                        meta: { requiresPermission: abilities.VIEW_REASON, requiresLicense: licenseModules.REASON_WEB  },
                    },
                    {
                        path: 'bundles',
                        component: () => import('@/views/Settings/Bundle/Index.vue'),
                        name: 'bundles',
                        meta: { requiresPermission: abilities.VIEW_BUNDLE }
                    }
                ]
            },
            {
                name: "settings-user",
                path: "settings-user",
                component: () => import('../views/Settings/Layout/BaseSettingUserLayout.vue'),
                children: [
                    {
                        name: "settings-users",
                        path: "users",
                        component: () => import('@/views/Settings/User/User.vue'),
                        meta: { requiresPermission:  abilities.VIEW_USER },
                    },
                    {
                        name: "settings-users-permission-view",
                        path: ':id/view',
                        component: () => import('../views/Settings/User/ViewUserPermission.vue'),
                        meta: { requiresPermission:  abilities.USER_PERMISSION }
                    },
                    {
                        name: "settings-rights",
                        path: "rights",
                        component: () => import('../views/Settings/Right/Right.vue'),
                        meta: { requiresPermission:  abilities.VIEW_RIGHT }
                    },
                    {
                        name: "settings-rights-view",
                        path: 'settings/rights/:id/view',
                        component: () => import('../views/Settings/Right/RightView.vue'),
                        meta: { requiresPermission:  abilities.RIGHT_PERMISSION }
                    },
                ]
            },
            {
                name: "settings-system",
                path: "settings-system",
                component: () => import('../views/Settings/Layout/BaseSettingSystemLayout.vue'),
                children: [
                    {
                        name: "settings-payment",
                        path: "payment",
                        component: () => import('@/views/Settings/Payment/index.vue'),
                        meta: { requiresPermission:  abilities.VIEW_PAYMENT_TYPE,requiresLicense: licenseModules.PAYMENT_TYPE_WEB  }
                    },
                    {
                        name: "settings-normalization",
                        path: "normalization",
                        component: () => import('@/views/Settings/Normalization/index.vue'),
                        meta: { requiresPermission:  abilities.VIEW_NORMALIZED_KEY,requiresLicense: licenseModules.NORMALIZATION_WEB }
                    },
                ]
            },

            {
                name: "settings-multi-society",
                path: "settings-multi-society",
                component: () => import('../views/Settings/Layout/BaseSettingMultiSocietyLayout.vue'),
                children: [

                ]
            },
            ShopRoutes,
            {
                name: "user-profile",
                path: "user",
                component: () => import('../views/User/LayoutUserAccount/BaseSettingUserLayout.vue'),
                children: [
                    {
                        path: 'profile',
                        component: () => import('@/views/User/Profil.vue'),
                        name: 'profile',
                        meta: { requiresPermission: abilities.VIEW_USER_PROFILE },
                    },
                    {
                        path: 'licence',
                        component: () => import('@/views/User/LayoutUserAccount/UserLicence.vue'),
                        name: 'user-licence',
                    },
                ]
            },
            {
                path: '/admin/permission-denied/403',
                name: 'PermissionDenied',
                component: PermissionDeniedView,
            },

        ]
    },
    posRoute,
    {
        path: '/legal/:type',
        name: 'legal-page',
        component: () => import('@/views/Legal/LegalPage.vue'),
        meta: { redirectIfAuthenticated: true, public: true },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundPageView
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

const { hasLicense } = useLicense()

// const buildLicenseCheckParams = (user = null) => {
//     const params = {}
//     const currentUserId = user?.id || store.getters['user/currentUser']?.id
//     const currentLicenseKey = store.getters['license/getLicense']?.license_key
//
//     if (currentUserId) {
//         params.external_entity_id = currentUserId
//     }
//
//     if (currentLicenseKey) {
//         params.license_key = currentLicenseKey
//     }
//
//     return params
// }

router.beforeEach(async (to, from, next) => {
    if(to.name !== from.name) {
        NProgress.start()
        if (to.meta?.showLoader !== false) {
            store.commit(UPDATE_APP_LOADING_STATUS, true)
        }else {
            store.commit(UPDATE_APP_MODULE_LOADING_STATUS, true)
        }
    }

    if (to.matched.some(m => m.meta.redirectIfTenant)) {
        if(isSubDomain()) {
            if (!store.getters['auth/isAuthenticated']) {
                return next('/login')
            }else {
                return next('/admin/dashboard')
            }
        }
    }

    if (to.matched.some(m => m.meta.requiresTenant)) {
        if(!isSubDomain()) {
            return next('/create_account')
        }
    }

    if (to.matched.some(m => m.meta.requiresTenant)) {
        if(!isSubDomain()) {
            return next('/delete_account')
        }
    }

    if (to.matched.some(m => m.meta.requiresAuth)) {
        if (!store.getters['auth/isAuthenticated']) {
            return next('/login')
        } else {
            const response = await axios.get(`/get/user`)
            if (response.status === 204) {
                store.dispatch('auth/logout', true)
            } else {
                store.dispatch('permission/loadPermissions')
                store.dispatch('moduleAccess/loadModules')
                await store.dispatch('license/checkHasLicense')
                store.dispatch('offices/loadOfficesBySocieties')
            }
        }
    }

    if (to.matched.some(m => m.meta.redirectIfAuthenticated) && store.getters['auth/isAuthenticated']) {
        return next('/admin/dashboard')
    }

    let accessModule = to.matched[to.matched.length - 1].meta?.requiresAccess;

    if (accessModule) {
        let hasModuleAccess = await checkModule(accessModule);
        if (!hasModuleAccess) {
            return next(`/admin/permission-denied/403`);
        }
    }

    let permissions = to.matched[to.matched.length - 1].meta?.requiresPermission

    if (permissions && permissions.length) {
        let hasAccess = await checkPermission(permissions);
        if (!hasAccess) {
            return next(`/admin/permission-denied/403`);
        }
    }

    let requiredLicense = to.matched[to.matched.length - 1].meta?.requiresLicense

    if (requiredLicense) {
        if (!store.getters['license/licenses']?.length) {
            await store.dispatch('license/checkHasLicense')
        }

        if (!hasLicense(requiredLicense)) {
            return next(`/admin/permission-denied/403`)
        }
    }

    return next()

})

router.afterEach((to) => {
    NProgress.done()
    store.commit(UPDATE_APP_LOADING_STATUS, false)
    store.commit(UPDATE_APP_MODULE_LOADING_STATUS, false)

    const btn = document.getElementById('support-trigger')
    if (btn) {
        const isAuthRoute = to.matched.some(m => m.meta?.redirectIfAuthenticated !== undefined)
        btn.style.display = isAuthRoute ? 'none' : ''
    }
})

export default router
